import React from "react";
import "./watch.css";

const videos = [
  {
    id: 1,
    title: "Cardinals 1 - Bluejays 0",
    type: "youtube",
    embedUrl: "https://youtube.com/embed/p9i0EnNVLKU?si=eteCrOKYUvbaBi6f",
  },
  {
    id: 2,
    title: "Stereo Talk",
    type: "youtube",
    embedUrl: "https://www.youtube.com/embed/1hxd-0widEc?si=KKwX2GYzYFZ2bapk",
  },
];

export default function Watch() {
  return (
    <main className="page watch-page">
      <section className="panel watch-panel">
        <h1>Watch</h1>
        <h2 className="video-muted">Charcuterie</h2>

        <div className="video-list">
          {videos.map((v) => (
            <div className="video-file" key={v.id}>
              <div className="video-file-meta">
                <div className="video-file-title"><h3>{v.title}</h3></div>

                {v.type === "youtube" ? (
                  <div className="video-embed-wrapper">
                    <iframe
                      className="video-iframe"
                      src={v.embedUrl}
                      title={v.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    />
                  </div>
                ) : (
                  <audio controls className="video-audio">
                    <source src={v.src} type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}